import { useTranslation } from '@lichtblick/i18next';
import { Colors, TextVariants } from '@lichtblick/theme';

import { Approved } from './images/Approved';
import { Rejected } from './images/Rejected';
import { Waiting } from './images/Waiting';
import { Container } from './Status.styles';

import { Text } from '../Text';

export type StatusOptions = 'approved' | 'automaticallyApproved' | 'rejected' | 'open';
type StatusProps = { type: StatusOptions };

const mapper = (type: StatusOptions) => {
  switch (type) {
    case 'approved':
      return {
        image: <Approved />,
        text: 'approved',
      };
    case 'automaticallyApproved':
      return {
        image: <Approved />,
        text: 'automaticallyApproved',
      };
    case 'rejected':
      return {
        image: <Rejected />,
        text: 'waitingForResubmit',
      };
    case 'open':
      return {
        image: <Waiting />,
        text: 'waiting',
      };
    default:
      break;
  }
};

export const Status = ({ type }: StatusProps) => {
  const { t } = useTranslation(['common', 'items']);

  const data = mapper(type);

  return (
    <Container>
      {data?.image}
      <Text $variant={TextVariants.header.s} color={Colors.gray[20]}>
        {t(`items:itemStatus:${data?.text}`)}
      </Text>
    </Container>
  );
};
